import { Button } from 'antd';
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

const NotFoundComponent = () => {
  return (
    <div style={{ textAlign: 'center' }}>
      <b>You don't have a right to access this page. Please go back</b>
      <Link to="/"><br /><Button type="primary">Home</Button></Link>
    </div>
  )
}

const ProtectAdminRoute = ({ user, children }) => {
  if (user) {
    if (!user.admin) {
      return <NotFoundComponent />
    }
    return children
  } else {
    return <NotFoundComponent />
  }
};

const TeamAdminRoute = ({ user, children, isTeamAdmin }) => {
  if (user) {
    if (!user.admin && !isTeamAdmin) {
      return <NotFoundComponent />
    }
    return children
  } else {
    return <NotFoundComponent />
  }
}

const mapStateToProps = (state) => {
  return {
    user: (state && state.app && state.app.user) || {}
  }
}

export const ProtectTeamAdminRoute = connect(mapStateToProps)(TeamAdminRoute);

export default connect(mapStateToProps)(ProtectAdminRoute);